import { render, staticRenderFns } from "./DisplayContainer.vue?vue&type=template&id=6b1c5fc0&scoped=true&"
import script from "./DisplayContainer.vue?vue&type=script&lang=ts&"
export * from "./DisplayContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayContainer.vue?vue&type=style&index=0&id=6b1c5fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c5fc0",
  null
  
)

export default component.exports